/**
 * Accès à la base pour les modules de paiement.
 *
 * ## Pourquoi ce fichier existe
 *
 * `src/lib/supabase.ts` expose un client typé par `Database`
 * (`src/lib/database.types.ts`). Ce fichier de types est incomplet : 474 lignes
 * pour 51 tables. Les six tables et trois vues du modèle d'allocation n'y
 * figurent pas, donc `supabase.from('payments')` ne compile pas.
 *
 * La régénération a été tentée. Le générateur produit des types qui visent une
 * version de `@supabase/supabase-js` plus récente que celle du projet — 2.49.4
 * ici — et la résolution de `GenericSchema` échoue alors sur tout le schéma, pas
 * seulement sur les nouvelles tables. **Monter la dépendance est une décision à
 * prendre à part**, avec ses propres tests : ce n'est pas un effet de bord
 * acceptable d'un ajout de tables.
 *
 * D'où ce compromis, tenu en un seul endroit : le client est ré-typé sans
 * schéma, et **chaque module annote lui-même la forme des lignes qu'il lit**.
 * Le typage n'est donc pas perdu, il est déclaré à la main plutôt que généré —
 * et les formes déclarées sont celles de la migration, qui est la référence.
 *
 * C'est la même instance de client : même session, même stockage. Créer un
 * second client aurait produit deux sessions parallèles, exactement le bug
 * corrigé lors de la fusion des deux applications.
 *
 * ## À faire le jour où la dépendance monte
 *
 *     supabase gen types typescript --project-id <ref> > src/lib/database.types.ts
 *
 * puis remplacer `db` par `supabase` dans les modules de paiement et supprimer
 * ce fichier.
 */

import type { SupabaseClient } from '@supabase/supabase-js';
import { supabase } from '../supabase';

export const db = supabase as unknown as SupabaseClient;
